// src/components/Cover/Cover.js

import React from "react";
import "./Cover.css";

import coverImg from "../../assests/cover_photo/cover.png";
import logo from "../../assests/logo.jpeg";
const handleBookNow = () => {
  const appointmentSection = document.getElementById("appointment");

  if (appointmentSection) {
    appointmentSection.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};
function Cover() {
  return (
    <section className="hero-section">
      {/* Background Cover Image */}
      <img src={coverImg} alt="Rootly Cover" className="hero-image" />

      {/* Overlay Content */}
      <div className="hero-overlay">
        <div className="hero-content">
          <p className="hero-tagline">Natural • Safe • Personalized</p>

          <h1>
            Healing From <br /> The Root Up
          </h1>

          <p className="hero-description">
            Complete natural and holistic care for you and your family through
            personalized homeopathic treatment.
          </p>

          <div className="hero-buttons">
            <button className="primary-btn" onClick={handleBookNow}>
              Book Appointment
            </button>
          </div>
        </div>
      </div>

      {/* Floating Center Logo */}
      <div className="floating-logo">
        <img src={logo} alt="Rootly Logo" />
      </div>
    </section>
  );
}

export default Cover;
